import React, { Component } from 'react';
import { Wrapper, Icon, Title, Content } from './components';
import { Responsive } from '../';

class Service extends Component {
	render() {
		return (
			<span>
				<Responsive.Desktop>
					<Wrapper>
						<Icon name={this.props.icon} />
						<Title>
							{this.props.title}
						</Title>
						<Content>{this.props.content}</Content>
					</Wrapper>
				</Responsive.Desktop>
				<Responsive.Mobile>
					<Wrapper mobile>
						<Title mobile>
							<Icon name={this.props.icon} mobile="mobile"/>
							<br />
							<br />
							{this.props.title}
						</Title>
						<Content mobile>{this.props.content}</Content>
					</Wrapper>
				</Responsive.Mobile>
			</span>
		);
	}
}

export default Service;


// WEBPACK FOOTER //
// ./src/components/service/index.js